import { createPaletteFromOptions } from '../../palette'
import { paletteDark } from './palette/dark/palette-dark'
import { paletteLight } from './palette/light/palette-light'
import { type TenantPaletteConfig } from '../types'

/**
 * PPL tenant palette.
 *
 * This intentionally duplicates the DHL light/dark palette setup as a starting
 * point, so PPL can diverge later without affecting DHL.
 */
export const pplPalette: TenantPaletteConfig = {
  light: createPaletteFromOptions(paletteLight),
  dark: createPaletteFromOptions(paletteDark),
}
